export function useConfirm(settings: {
  text: string
  description?: string
}): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const confirmed = window.confirm([settings.text, settings.description].filter(Boolean).join('\n'));
    resolve(confirmed);
  });
}
